import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { connect } from "react-redux";
import InfiniteScroll from "react-infinite-scroller";
import ImgNoDocsToSign from "../../assets/img/sign-noDocs.svg";
import { FormattedMessage } from "react-intl";

import SignatureCard from "./signatureCard/index.jsx";
import LoaderSimple from "../general/loader";

const SignatureList = ({
  docs,  
  signDocument,
  total,
  getDocumentsToSign,
  prevPath
}) => {
  const [hasMoreItems, setHasMoreItems] = useState(true);

  const [page, setPage] = useState(0);
  const totalPages = total && total.page.totalPages;
  const isGettingDocumentsToSign = useSelector(state => state.signature.isGettingDocumentsToSign);
  useEffect(() => {
    if (prevPath !== "/da-firmare" || isGettingDocumentsToSign) return;
    setPage(total.page.number);
  }, [prevPath]);

  function moreItems() {
    if (isGettingDocumentsToSign && !page) return;
    if (page + 1 === totalPages) {
      setHasMoreItems(false);
    } else {
      getDocumentsToSign(
        page + 1,
        12,
        true
      );
    }

    setPage(page + 1);
  }

  const signatureCards = () => {
    const signatureArray = [];
    Object.keys(docs).forEach(function(key, index) {
      signatureArray.push(<SignatureCard
        key={key}
        rowData={docs[key]}
        signDocument={signDocument}        
      />);
    });

    return signatureArray;
  };

  return (
    <React.Fragment>
      {docs && docs.length > 0 ? (
        <div style={{ backgroundColor: "#ffffff" }}>
          <div>
            <InfiniteScroll
              threshold={30}
              pageStart={0}
              loadMore={moreItems.bind(this)}
              hasMore={hasMoreItems}
              loader={<LoaderSimple />}
              useWindow={false}
            >
              <div
                style={{
                  display: "flex",
                  flexFlow: "row wrap",
                  justifyContent: "center",
                  padding: "20px"
                }}
              >
                {signatureCards()}
              </div>
              <br />
            </InfiniteScroll>
          </div>
        </div>
      ) : (
        <div className="containerList">
          <div
            style={{
              flex: "0 0 auto",
              margin: "auto"
            }}
          >
            <div className="textEmptyDocs">
              <FormattedMessage id="signature.emptyDocs" />{" "}
            </div>
            <img
              style={{ height: "458px", width: "458px" }}
              src={ImgNoDocsToSign}
              alt=""
            />
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default connect(null, null)(SignatureList);
